import { TDescriptionValue } from 'shared/types/typographyComponents';
import { TTwoUtpBlock } from 'shared/types/utp';

export const MODELS = [
  {
    image: 'eye',
    title: 'CPM',
    text: 'оплата за 1000 показов',
  },
  {
    image: 'touch',
    title: 'CPC',
    text: 'оплата за клик',
  },
];

export const UTP: TTwoUtpBlock = [
  { title: 'Спецпроекты', description: 'Шаблонные или кастомные кампании', image: 'web-page' },
  {
    title: `Сервис Циан.Аудитория`,
    description: 'Реклама на внешних площадках ',
    notice: 'VK, OK, Яндекс.Дзен и др.',
    image: 'switcher',
  },
];

export const LIST: TDescriptionValue[][] = [
  [{ value: 'Донесение информации о проекте' }],
  [{ value: 'Продвижение акций и спецпредложений' }],
  [{ value: 'Повышение узнаваемости бренда среди целевой аудитории' }],
];
